@let boxClass = cardView
  ? 'status-box'
  : 'status-box-details-page';

@let contentTemplate = cardView
  ? staticStatusBoxTempalte
  : staticStatusBoxDetailsTemplate;

@if (canEdit) {
  <div
    ngDropdown
    [templateRef]="filterTemplate"
    [style.background-color]="getStatusBoxColor()"
    [class]="boxClass"
  >
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </div>
} @else {
  <div
    [style.background-color]="getStatusBoxColor()"
    [class]="boxClass"
  >
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </div>
}


<ng-template #staticStatusBoxTempalte>
  <div class="status-stars">
    <rating [(ngModel)]="job.priority" [max]="3" [readonly]="true" [customTemplate]="jobStatusTemplate"></rating>
  </div>
  <div class="status-text">{{ jobStatuses[job.status].toString().replace('_', ' ') }}</div>
</ng-template>

<ng-template #staticStatusBoxDetailsTemplate>
  <div class="status-text-details-page" [class.separator]="showDropdown">
    {{ jobStatuses[job.status].toString().replace('_', ' ') }}
  </div>

  @if(showDropdown) {
    <div class="drodpdown-arrow">
      <i class="material-symbols-outlined">keyboard_arrow_down</i>
    </div>
  }
</ng-template>

<ng-template #filterTemplate>
  <div class="filters-container">
    <div class="status-container">
      <div class="status-container-title">{{ T.common.select_status | translate }}</div>
      <div class="status-container-entries-container">
        <app-filters-list-entries
          [filterType]="filterTypes.Job_Status"
          [entries]="availableStatusFilters"
          [selectedEntries]="[selectedStatusFilter]"
          [mobile]="mobile"
          [required]="true"
          (entrySelected)="onEntrySelected($event)"
        >
        </app-filters-list-entries>
      </div>
    </div>

    @if(showRating) {
      <div class="priority-container">
        <div class="priority-container-title">{{ T.common.select_priority | translate }}</div>
        <div class="priority-container-entries-container">
          <app-filters-list-entries
            [filterType]="filterTypes.Job_Priority"
            [entries]="availablePriorityFilters"
            [selectedEntries]="[selectedPriorityFilter]"
            [mobile]="mobile"
            [required]="true"
            (entrySelected)="onEntrySelected($event)"
          >
          </app-filters-list-entries>
        </div>
      </div>
    }

    <app-filters-desktop-footer
      *forScreen="'desktop'"
      [useClearAllButton]="false"
      [useCancelApplyButtons]="true"
      [clearDisabled]="!filters.length"
      [applyDisabled]="false"
      (clear)="onClear($event)"
      (cancel)="onCancel()"
      (apply)="onApply()"
    >
    </app-filters-desktop-footer>

    <app-filters-mobile-footer
      *forScreen="'mobile'"
      [applyDisabled]="false"
      (apply)="onApply()"
    ></app-filters-mobile-footer>
  </div>
</ng-template>

<ng-template #jobStatusTemplate let-i="index" let-v="value">
  <!-- Note: i+1 is used to map zero-based index to JobPriority enum -->
  <span
    class="material-symbols-outlined star"
    [ngStyle]="{ color: i < v ? '#ffffff' : '#e0e0e0', opacity: i < v ? '1' : '0.2' }"
    title=""
    [app-tooltip]="{ position: ['top'], message: priorityTooltipMessage[i+1] }"
    >star</span
  >
</ng-template>
